import { FC } from 'react';

import { twMerge } from 'tailwind-merge';

import { Input } from '@/shared/ui';

import { ICurrency } from '../../types';
import { CurrenciesSelect } from '../currencies-select';
import { CurrencyIcon } from '../currency-icon';
import { TAmountInput } from './types';

export const AmountInput: FC<TAmountInput> = ({
  value,
  onValueChange,

  onSelectCurrency,
  selectDisabled,
  placeholder,
  disabled,
  isInvalid,
  variant,
  size,
  className,
  currency,
  defaultCurrency = null,
}) => {
  const selectCurrencyHandler = (currency: ICurrency | null) => {
    onSelectCurrency?.(currency);
  };

  return (
    <div className={twMerge('flex gap-x-[14px]', className)}>
      <CurrenciesSelect
        value={currency}
        onSelect={selectCurrencyHandler}
        isInvalid={isInvalid}
        disabled={selectDisabled || disabled}
        triggerProps={{
          variant,
          size,
          classNames: {
            wrapper: 'pl-3 pr-2 gap-0',
            icon: 'w-4 ml-0',
          },
          className: 'w-max shrink-0 min-w-[108px] max-w-[108px]',
        }}
        renderTriggerValue={(currency) => (
          <div className="flex w-full items-center gap-2">
            <CurrencyIcon
              ticker={currency?.option?.ticker}
              className="shrink-0"
            />
            <p className="flex-1 truncate typography-16r">
              {currency?.option?.ticker ?? 'Currency'}
            </p>
          </div>
        )}
      />

      <Input
        value={value}
        onValueChange={onValueChange}
        placeholder={placeholder}
        disabled={disabled}
        isInvalid={isInvalid}
        variant={variant}
        size={size}
        className="flex-1"
        isNumber
      />
    </div>
  );
};
